var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDrawerPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeWidth: 0.3,
    d: "M1.065 6.95v6.89c0 .924.752 1.676 1.676 1.676h7.65c.838 0 1.518-.68 1.518-1.518V6.95H1.063zm9.325 9.631H2.741c-1.51 0-2.74-1.23-2.74-2.74V6.417c0-.294.237-.532.532-.532H12.44c.295 0 .533.238.533.532v7.58c0 1.424-1.159 2.583-2.583 2.583h0z",
    transform: "translate(-41 -275) translate(42 276)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeWidth: 0.3,
    d: "M2.713 5.886h7.55V4.839c0-2.082-1.695-3.774-3.777-3.774-2.081 0-3.773 1.692-3.773 3.774v1.047zm8.081 1.063H2.181c-.294 0-.532-.237-.532-.531v-1.58C1.649 2.17 3.819 0 6.486 0c2.669 0 4.84 2.17 4.84 4.839v1.579c0 .294-.238.53-.532.53h0z",
    transform: "translate(-41 -275) translate(42 276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.486 10.307c-.507 0-.918.416-.918.926s.411.927.918.927c.511 0 .926-.416.926-.927 0-.51-.415-.926-.926-.926m0 2.917c-1.093 0-1.98-.894-1.98-1.991s.887-1.99 1.98-1.99c1.097 0 1.99.893 1.99 1.99s-.893 1.99-1.99 1.99",
    transform: "translate(-41 -275) translate(42 276)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawerPassword);
export default __webpack_public_path__ + "static/media/iconDrawerPassword.40965752.svg";
export { ForwardRef as ReactComponent };